import { createContext, useContext, useState } from 'react'
import { useSessione } from './SessioneProvider'

const CHIAVE_VERBALE_DATI_CONDUCENTE = 'chiaveVerbaleDatiConducente'

const DatiConducenteContext = createContext()

function DatiConducenteProvider(props) {
  const { children } = props

  const {
    [CHIAVE_VERBALE_DATI_CONDUCENTE]: chiaveVerbale,
    salvaInSessione,
    rimuoviDaSessione,
  } = useSessione()

  const [verbale, salvaVerbale] = useState(null)
  const [listaVerbali, setListaVerbali] = useState(null)
  const [chiaveVerbaleCompletamento, setChiaveVerbaleCompletamento] = useState(null)

  function salvaChiaveVerbale(chiaveVerbale) {
    salvaInSessione(CHIAVE_VERBALE_DATI_CONDUCENTE, chiaveVerbale)
  }

  function pulisciChiaveVerbale() {
    rimuoviDaSessione(CHIAVE_VERBALE_DATI_CONDUCENTE)
  } 

  const verbaliContextValue = {
    isModalitaWeb : Boolean(chiaveVerbale),
    verbale,
    chiaveVerbale,
    listaVerbali,
    chiaveVerbaleCompletamento, 
    salvaVerbale,
    salvaChiaveVerbale,
    pulisciChiaveVerbale,
    setListaVerbali,
    setChiaveVerbaleCompletamento,
  }

  return (
    <DatiConducenteContext.Provider value={verbaliContextValue}>
      {children}
    </DatiConducenteContext.Provider>
  )
}

function useDatiConducenteContext() {
  return useContext(DatiConducenteContext)
}

// eslint-disable-next-line react-refresh/only-export-components
export { DatiConducenteProvider, useDatiConducenteContext, CHIAVE_VERBALE_DATI_CONDUCENTE }
